export default "__VITE_ASSET__CZG9sLTT__"